import { Route, Routes } from "react-router-dom";
import MainPage from "./MainPage/mainPage";
import HomePage from "./MainPage/homePage";
import Download from "./download";
import Disclaimer from "./Disclaimer/disclaimer";
import Layout from "./layout";
import Individuals from "./Individuals/individuals";
import HealthcareProviders from "./HealthcareProviders/healthcareProviders";
import RequestDemo from "./RequestDemo/requestDemo";
import TermsOfUse from "./TermsOfUse/termsOfUse";
import AboutUs from "./AboutUs/aboutUs";
import Faq from "./FaQ/faq";
import ContactUs from "./ContactUs/contactUs";

export default () => {
    return (
        <Routes>
            <Route index path="/preview" element={<MainPage />}></Route>
            <Route path="/" element={<HomePage />}></Route>
            <Route element={<Layout />}>
                <Route path="/individuals" element={<Individuals />}></Route>
                <Route path="/healthcare-providers" element={<HealthcareProviders />}></Route>
                <Route path="/request-demo" element={<RequestDemo />}></Route>
                <Route path="/terms-of-use" element={<TermsOfUse />}></Route>
                <Route path="/about-us" element={<AboutUs />}></Route>
                <Route path="/faq" element={<Faq />}></Route>
                <Route path="/contact-us" element={<ContactUs />}></Route>
            </Route>
            <Route path="/disclaimer" element={<Disclaimer />}></Route>
            <Route path="/download" element={<Download />}></Route>
        </Routes>
    );
};


